class TabSwitch extends HTMLElement {
    constructor() {
        super();
        this.inputValue = 1;
        this.initialRender();
        // this.tabsSwitch = document.querySelector('.tabs__switch');
    }

    connectedCallback(){
        if(window.innerWidth <= 900){
            this.querySelectorAll('.switch__content').forEach((value) => {
                value.addEventListener('click', this.renderSection)
            });
        }
        else{
            this.querySelectorAll('.switch__content').forEach((value) => {
                value.addEventListener('mouseover', this.renderSection)
            });
        }
    }

    initialRender() {
        if (this.inputValue == 1) {
            let renderImage = document.querySelector(`.tab__image[data-index="${this.inputValue}"]`);
            renderImage.classList.remove('inactive__image');
            renderImage.classList.add('active__image');
            let renderBar = document.querySelector(`.switch__content[data-index="${this.inputValue}"]`);
            renderBar.classList.remove('inactive__bar');
            renderBar.classList.add('active__bar');
            let renderHeading = document.querySelector(`.tab__heading[data-index="${this.inputValue}"]`);
            renderHeading.classList.remove('inactive__heading');
            renderHeading.classList.add('active__heading');
            let renderTabs = document.querySelector(`.sub__content[data-index="${this.inputValue}"]`);
            renderTabs.classList.remove('inactive__content');
            renderTabs.classList.add('active__content');
        }
    }

    renderSection() {
        let inputValue = this.dataset.index;
        document.querySelectorAll('.tab__image').forEach((item) => {
            item.classList.remove('active__image')
            item.classList.add('inactive__image');
        })
        document.querySelectorAll('.switch__content').forEach((item) => {
            item.classList.remove('active__bar')
            item.classList.add('inactive__bar');
        })
        document.querySelectorAll('.tab__heading').forEach((item) => {
            item.classList.remove('active__heading')
            item.classList.add('inactive__heading');
        })
        document.querySelectorAll('.sub__content').forEach((item) => {
            item.classList.remove('active__content');
            item.classList.add('inactive__content');
        })
        let renderImage = document.querySelector(`.tab__image[data-index="${inputValue}"]`);
        renderImage.classList.remove('inactive__image');
        renderImage.classList.add('active__image');
        let renderBar = document.querySelector(`.switch__content[data-index="${inputValue}"]`);
        renderBar.classList.remove('inactive__bar');
        renderBar.classList.add('active__bar');
        let renderHeading = document.querySelector(`.tab__heading[data-index="${inputValue}"]`);
        renderHeading.classList.remove('inactive__heading');
        renderHeading.classList.add('active__heading');
        let renderTabs = document.querySelector(`.sub__content[data-index="${inputValue}"]`);
        renderTabs.classList.remove('inactive__content');
        renderTabs.classList.add('active__content');
    }

}


customElements.define('tab-switch', TabSwitch);